import React, {Component} from 'react';
import styled from 'styled-components';
import media from '../MediaQueries.js';
import { Collapse, Navbar, NavbarToggler, NavbarBrand, Nav, NavItem,
        NavLink, Container, Row, Col, Jumbotron, Button } from 'reactstrap';

const Story = (props) => ( 
	<Container_s id="AboutUsSectionID" fluid>
		<Container_1000>
			<h3>About The Owner</h3>
			<Row>

				<Col xs="12" md={{size: 7, order: 7}}>
					<img src={require("../media/abouttheownerpic.jpg")}></img>
				</Col>
				<Col xs="12" md={{size: 5, order: 5}}>
					<p>
						Theresa Tubbs is the creator of Primitives Candles. Primitives Candles are 
						handpoured rustic candles from the mountains of Potter County, PA. Theresa makes her candles
						from the heart of the small town of Galeton. She has been serving her customers since
						1994, and takes tremendous pride in the craftsmanship of her candles and the high level of
						service delivered to every customer. This level of care and attention to detail
						can be expected on every order you place.
					</p>
				</Col>
			</Row>

			<TreeContainer>
				<Tree src={require("../media/tree.jpg")}></Tree>
			</TreeContainer>
		</Container_1000>
		
	</Container_s>
);

export default Story;


const Container_s = styled(Container)`
	padding: 20px 15px 20px 15px!important;
	text-align: center;
	background-color: #D0C1A0;
`;

const Container_1000 = styled(Container)`
	padding: 0!important;
	background-color: #D0C1A0;

	h3 {
		margin-bottom: 15px;
		font-weight: bold;
		font-size: 36px;
		${media.md` font-size: 38px; `}
		${media.lg` font-size: 40px; `}
		${media.xl` font-size: 42px; `}
		${media.xxl` font-size: 44px; `}
	}
	.row {
		background-color: #D0C1A0;

		.col-12 {
			background-color: #D0C1A0;
			padding-bottom: 20px;

			img {
				width: 100%;
				height: auto;
				display: block;
			}
			p {
				font-family: 'Raleway';
				font-size: 16px;
				text-align: left;

				${media.md` font-size: 17px; `}
				${media.lg` font-size: 18px; `}
				${media.xl` font-size: 19px; `}
			}
		}
	}

`;

const TreeContainer = styled.div`
	text-align: left;
	margin: 0 30px 0 30px;
	background-color: #D0C1A0;
`;

const Tree = styled.img`
	width: 114px!important;
	height: 130px!important;
	display: inline-block!important;
	text-align: right;
`;


// WEBPACK FOOTER //
// ./src/components/Story.js